<template>
  <section id="content">
    <div>
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <!-- <button v-on:click="onCreate" class="btn btn-primary">Create</button> -->
                  <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:center;">Name</th>
                    <th style="text-align:center;">Doc. Date</th>
                    <th style="text-align:left;">Customer</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">Bill To</th>
                    <th style="text-align:right;">Total Amount</th>
                    <th style="text-align:center;">Currency</th>
                    <th style="text-align:left;">Reference</th>
                    <th style="text-align:left;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <!-- <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a> -->
                    </td>
                    <td style="text-align:center;">{{ row.name }}</td>
                    <td style="text-align:center;">{{ row.documentDate }}</td>
                    <td style="text-align:left;">{{ row.customerName }}</td>
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td style="text-align:left;">{{ row.billName }}</td>
                    <td style="text-align:right;">{{ row.totalAmount }}</td>
                    <td style="text-align:center;">{{ row.currencyName }}</td>
                    <td style="text-align:center;">{{ row.reference }}</td>
                    <td style="text-align:center;">{{ row.status }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.customerId }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.billId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>

    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">SO Number</label>
                <div class="col-md-10">
                    <input type="text" id="filterSONumber" v-model="searchParam.name" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Document Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showDocDateFrom" ref="docDateFrom" :value=searchParam.doc_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterDocDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showDocDateFrom" ref="docDateTo" :value=searchParam.doc_date_to :format=DATE_FORMAT :input-attr="{ 'id': 'filterDocDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>               
              <div class="form-group">
                <label class="col-md-2 control-label">Reference</label>
                <div class="col-md-10">
                  <input type="text" id="filteReference" v-model="searchParam.reference" style="width:100%">
                </div>                     
              </div>                
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-10">
                  <input type="text" id="filteStatus" v-model="searchParam.status" style="width:100%">
                </div>                     
              </div>                                                                                         
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import select2 from '../../components/widgets/Select2'
import config from '../../config'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'SalesOrder',
  components: {
    datepicker, select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      item: null,
      listData: null,
      listDataTemp: null,
      listCurrency: null,
      listProject: null,
      listCustomer: null,
      listBillTo: null,
      listSOItem: null,
      listSOBillingPlan: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      searchParam: {
        name: '',
        doc_date_from: '',
        doc_date_to: '',
        reference: '',
        status: ''
      },
      showDocDateFrom: true,
      showDocDateTo: true,
      viewMode: MODE_NONE,
      callback: []
    }
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquirySalesOrderByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      // var keyWords = evt.target.value
      // var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      // this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.SortDirection = 'DESC'
      this.inquiryParam.SortExpression = 'DocumentDate'

      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      var arrCurrency = []
      var arrProject = []
      var arrCustomer = []

      api
        .request('Sales', 'get', '/api/SalesOrder/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages

          this.listDataTemp.forEach(itemSO => {
            // Populate currency
            arrCurrency.push(itemSO.currencyId)
            var arrCurrencyUnique = arrCurrency.filter(function(item, index) {
              return arrCurrency.indexOf(item) >= index
            })
            arrCurrency = arrCurrencyUnique

            // Populate project
            arrProject.push(itemSO.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique

            // Populate customer and bill to
            arrCustomer.push(itemSO.customerId)
            arrCustomer.push(itemSO.billId)
            var arrCustomerUnique = arrCustomer.filter(function(item, index) {
              return arrCustomer.indexOf(item) >= index
            })
            arrCustomer = arrCustomerUnique
          })
        })
        .then(response => {
          // Get currency
          if (arrCurrency.length === 0) {
            return
          } else {
            let whereClause = 'id in (' + arrCurrency.join(',') + ')'
            api
              .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCurrency.length +
                                            '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
              .then(response => {
                var data = response.data
                this.listCurrency = data.entity
              })
              .then(response => {
                // Get project
                let whereClause = 'id in (' + arrProject.join(',') + ')'
                api
                  .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                                '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
                  .then(response => {
                    var data = response.data
                    this.listProject = data.entity
                  })
                  .then(response => {
                    // Get customer and bill to
                    let whereClause = 'id in (' + arrCustomer.join(',') + ')'
                    api
                      .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCustomer.length +
                                                    '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
                      .then(response => {
                        var data = response.data
                        this.listCustomer = data.entity
                      })
                      .then(response => {
                        this.combineInquiry()
                      })
                      .catch(error => {
                        var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                        SweetAlert.fire('Error', message, 'error')
                      })
                  })
                  .catch(error => {
                    var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                    SweetAlert.fire('Error', message, 'error')
                  })
              })
              .catch(error => {
                var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                SweetAlert.fire('Error', message, 'error')
              })
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    combineInquiry() {
      this.listDataTemp.forEach(item => {
        var currencyName = ''
        this.listCurrency.some(function(itemCurrency, index) {
          if (item.currencyId === itemCurrency.id) {
            currencyName = itemCurrency.name
          }
        })
        item.currencyName = currencyName

        var projectName = ''
        this.listProject.some(function(itemProject, index) {
          if (item.projectId === itemProject.id) {
            projectName = itemProject.name
          }
        })
        item.projectName = projectName

        var customerName = ''
        this.listCustomer.some(function(itemCustomer, index) {
          if (item.customerId === itemCustomer.id) {
            customerName = itemCustomer.firstName + ' ' + itemCustomer.lastName
          }
        })
        item.customerName = customerName

        var billName = ''
        this.listCustomer.some(function(itemCustomer, index) {
          if (item.billId === itemCustomer.id) {
            billName = itemCustomer.firstName + ' ' + itemCustomer.lastName
          }
        })
        item.billName = billName
      })
      this.listData = this.listDataTemp
    },
    // onCreate() {
    //   this.callback.push({
    //     id: 0,
    //     mode: MODE_NONE,
    //     name: this.$route.name
    //   })
    //   let params = {
    //     id: 0,
        // customerName: row.customerName,
        // projectName: row.projectName,
        // billName: row.billName,
        // currencyName: row.currencyName,
    //     mode: MODE_CREATE,
    //     callback: this.callback
    //   }
    //   this.$router.push({ name: 'Sales Order Form', params: params })
    // },
    onDisplay(row) {
      this.callback.push({
        id: 0,
        mode: MODE_NONE,
        name: this.$route.name
      })
      let params = {
        id: row.id,
        customerName: row.customerName,
        projectName: row.projectName,
        billName: row.billName,
        currencyName: row.currencyName,
        mode: MODE_VIEW,
        callback: this.callback
      }
      this.$router.push({ name: 'Sales Order Form', params: params })
    },
    // onEdit(row) {
    //   this.callback.push({
    //     id: 0,
    //     mode: MODE_NONE,
    //     name: this.$route.name
    //   })
    //   let params = {
    //     id: row.id,
        // customerName: row.customerName,
        // projectName: row.projectName,
        // billName: row.billName,
        // currencyName: row.currencyName,
    //     mode: MODE_UPDATE,
    //     callback: this.callback
    //   }
    //   this.$router.push({ name: 'Sales Order Form', params: params })
    // },

    onApplyFilter() {
      var filterParams = []
      if (this.searchParam.name !== '') {
        filterParams.push(['name', '=', '\'' + this.searchParam.name + '\''])
      }

      let dateFrom
      if ($('#filterDocDateFrom').val() === '') {
        dateFrom = moment('01.01.1900', this.DATE_FORMAT)
      } else {
        this.searchParam.doc_date_from = $('#filterDocDateFrom').val()
        dateFrom = moment(this.searchParam.doc_date_from, this.DATE_FORMAT)
      }
      dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)
      filterParams.push(['DocumentDate', '>=', '\'' + dateFrom + '\''])

      let dateTo
      if ($('#filterDocDateTo').val() === '') {
        dateTo = moment('31.12.9999', this.DATE_FORMAT)
      } else {
        this.searchParam.doc_date_to = $('#filterDocDateTo').val()
        dateTo = moment(this.searchParam.doc_date_to, this.DATE_FORMAT)
      }
      dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)
      filterParams.push(['DocumentDate', '<=', '\'' + dateTo + '\''])

      if (this.searchParam.reference !== '') {
        filterParams.push(['Reference', '=', '\'' + this.searchParam.reference + '\''])
      }
      if (this.searchParam.status !== '') {
        filterParams.push(['status', '=', '\'' + this.searchParam.status + '\''])
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.name = ''

      this.searchParam.doc_date_from = ''
      this.searchParam.doc_date_to = ''

      this.searchParam.reference = ''
      this.searchParam.status = ''

      this.showDocDateFrom = false
      this.$nextTick(() => {
        this.showDocDateFrom = true
      })

      this.showDocDateTo = false
      this.$nextTick(() => {
        this.showDocDateTo = true
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// SalesOrder.vue?02f38209